<template>
<div class="chapter">
<div class="inner_page">
<div class="dedication" id="dedication">
<h2 class="dedicationText"><em class="italic">To</em></h2>
<h2 class="dedicationText1">HENRY WILLIAMSON</h2>
<h2 class="dedicationText1"><em class="italic">at whose suggestion this book was begun, with whose encouragement and help it was written and ended</em></h2>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// WingedVictory_dedication.vue?2fa888cc